import { ConversationSourceType } from 'shared/interfaces/Conversation';

export const CONVERSATIONS_EXPORT_TIMEOUT_MS = 1_000_000;
export type ConversationFilter = 'dateRange' | 'handoffStatus' | 'sourceTypes' | 'takeoverStatus';

// The default window duration is 24 hours. After Human Agent permission is approved from Meta, the window will be 7 days.
export const TAKEOVER_WINDOW_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours
export const TAKEOVER_WINDOW_DURATION_TRANSLATION_KEY = '24_HOURS';

// This needs to be synced with backend if changed
export const TAKEOVER_MESSAGE_MAX_LENGTH: Partial<Record<ConversationSourceType, number>> = {
  [ConversationSourceType.WHATSAPP]: 4096,
  [ConversationSourceType.FACEBOOK]: 2000,
  [ConversationSourceType.INSTAGRAM]: 1000
};

export const MAX_CHAT_IMAGE_UPLOAD_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_CHAT_IMAGE_UPLOAD_COUNT = 5;
